var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-eg-task",class:[_vm.classLength, _vm.classFloor]},[_c('div',{staticClass:"at-eg-task-inner-ptf",style:("background-color: " + _vm.task.color + "; border= 1px solid " + _vm.task.color + ";"),attrs:{"data-id":_vm.task.index}})])
}
var staticRenderFns = []

export { render, staticRenderFns }